import { DocumentsScreen } from '@/features/documents/components/documents-screen';

export function DocumentsPage() {
  return <DocumentsScreen />;
}
